module.exports = __webpack_public_path__ + "static/img/epidemic.f4d29e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic.png
// module id = 193X
// module chunks = 1